<template>
    <kgr-form-scaffold
        :pending="pending"
        :with-back-button="false"
        :save-button-disabled="saveButtonDisabled"
        :with-primary-buttons="isEditable"
        @primaryBtnClicked="save"
    >
        <kgr-loader v-if="loading" />
        <div v-else>
            <h2 class="kgr-headline kgr-headline--h2 kgr-headline--text">
                {{ $t('Prüfungen im Kursmodul') }}
            </h2>
            <div class="kgr-row">
                {{ $t('club.exam.settings.activeForOfferings.intro') }}
            </div>

            <div class="kgr-inputGroup">
                <kgr-checkbox
                    :inactive="!clubExamSettings.hasAccessToOfferingModule"
                    v-model="clubExamSettings.activeForOfferings"
                    :label="$t('Prüfungen im Kursmodul verfügbar machen')"
                />
            </div>

            <template v-if="clubExamSettings.usabilityPassAvailable">
                <hr class="kgr-separator kgr-separator--light" />
                <h2 class="kgr-headline kgr-headline--h2 kgr-headline--text">
                    {{ $t('Brauchbarkeitspass für Hunde') }}
                </h2>
                <div class="kgr-row">
                    {{ $t('club.exam.settings.usabilityPassEnabled.intro') }}
                </div>

                <div class="kgr-inputGroup">
                    <kgr-checkbox
                        v-model="clubExamSettings.usabilityPassEnabled"
                        :label="$t('Erstellung der Brauchbarkeitspässe aktivieren')"
                    />
                </div>
            </template>
        </div>
    </kgr-form-scaffold>
</template>

<script>
import Checkbox from '../../../components/common/form/checkbox/Checkbox.vue';
import ClubExamSettings from '../../../js/dto/club/ClubExamSettings.js';
import ClubExamSettingsRepository from '../../../js/repository/club/ClubExamSettingsRepository.js';
import Error from '../../../js/model/Error.js';
import FormScaffold from '../../../components/common/form/FormScaffold.vue';
import Loading from '../../../components/common/Loading.vue';

export default {
    components: {
        'kgr-checkbox': Checkbox,
        'kgr-form-scaffold': FormScaffold,
        'kgr-loader': Loading,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            pending: false,
            loading: false,
            clubExamSettings: new ClubExamSettings(),
        };
    },
    computed: {
        saveButtonDisabled() {
            return this.loading || this.pending;
        },
    },
    created() {
        this.load(true);
    },
    methods: {
        load(setLoading) {
            this.loading = setLoading;
            ClubExamSettingsRepository.findByClubId(this.clubId)
                .then((response) => this.clubExamSettings = response)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        save() {
            this.pending = true;
            ClubExamSettingsRepository.update(this.clubId, this.clubExamSettings)
                .then(() => {
                    this.load(false);
                    this.$notify.success('saveChanges.success');
                })
                .catch(() => this.$notify.error('saveChanges.error'))
                .finally(() => this.pending = false);
        },
    },
};
</script>

<style scoped lang="scss">

</style>
